'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = require('@progress/kendo-base-components-vue-wrapper');

var _DataSourceProps = require('./DataSourceProps');

var _DataSourceProps2 = _interopRequireDefault(_DataSourceProps);

var _Filter = require('./Filter');

var _Filter2 = _interopRequireDefault(_Filter);

var _Group = require('./Group');

var _Group2 = _interopRequireDefault(_Group);

var _Schema = require('./Schema');

var _Schema2 = _interopRequireDefault(_Schema);

var _Sort = require('./Sort');

var _Sort2 = _interopRequireDefault(_Sort);

var _Transport = require('./Transport');

var _Transport2 = _interopRequireDefault(_Transport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    template: '<div></div>',
    props: _DataSourceProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _Filter2.default, _Group2.default, _Schema2.default, _Sort2.default, _Transport2.default],
    mounted: function mounted() {
        var _this = this;

        this.$watch(function (vm) {
            return [vm.filter, vm.filterValue, vm.filterField, vm.filterFilters, vm.filterLogic, vm.filterOperator].join();
        }, function () {
            _this.kendoDataSource.filter(_this.widgetOptions.filter);
        }, { deep: true });

        this.$watch(function (vm) {
            return [vm.group, vm.groupField, vm.groupDir, vm.groupAggregates].join();
        }, function () {
            _this.kendoDataSource.group(_this.widgetOptions.group);
        }, { deep: true });

        this.$watch(function (vm) {
            return [vm.aggregate, vm.aggregateAggregate, vm.aggregateField].join();
        }, function () {
            _this.kendoDataSource.aggregate(_this.widgetOptions.aggregate);
        }, { deep: true });

        this.$watch(function (vm) {
            return [vm.sort, vm.sortDir, vm.sortField, vm.sortCompare].join();
        }, function () {
            _this.kendoDataSource.sort(_this.widgetOptions.sort);
        }, { deep: true });

        this.$watch(function (vm) {
            return [vm.page].join();
        }, function () {
            _this.kendoDataSource.page(_this.widgetOptions.page);
        }, { deep: true });

        this.$watch(function (vm) {
            return [vm.pageSize].join();
        }, function () {
            _this.kendoDataSource.pageSize(_this.widgetOptions.pageSize);
        }, { deep: true });

        this.$watch(function (vm) {
            return [vm.data].join();
        }, function () {
            _this.kendoDataSource.data(_this.widgetOptions.data);
        }, { deep: true });
    }
};